import { render, staticRenderFns } from "./ContractorsInviteModal.vue?vue&type=template&id=2478cdf1&"
import script from "./ContractorsInviteModal.vue?vue&type=script&lang=js&"
export * from "./ContractorsInviteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2478cdf1')) {
      api.createRecord('2478cdf1', component.options)
    } else {
      api.reload('2478cdf1', component.options)
    }
    module.hot.accept("./ContractorsInviteModal.vue?vue&type=template&id=2478cdf1&", function () {
      api.rerender('2478cdf1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/contractors/ContractorsInviteModal.vue"
export default component.exports